var _defs, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetrics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "metrics_svg__a",
    x1: 6.57,
    y1: 7.06,
    x2: 6.57,
    y2: 3.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#773adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b77af4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "metrics_svg__b",
    x1: 11.02,
    y1: 11.15,
    x2: 11.02,
    y2: 7.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#773adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b77af4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "metrics_svg__c",
    x1: 15.15,
    y1: 3.79,
    x2: 15.15,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#773adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b77af4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "metrics_svg__d",
    x1: 2.85,
    y1: 11.86,
    x2: 2.85,
    y2: 8.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#773adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b77af4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b796f9",
    d: "M14.73 1.62l-3.99 7.1-4.22-4.3-4.35 5.64 1.02.8 3.45-4.45 4.38 4.47 4.84-8.61-1.13-.65z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.57,
    cy: 5.41,
    rx: 1.64,
    ry: 1.65,
    fill: "url(#metrics_svg__a)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.02,
    cy: 9.5,
    rx: 1.64,
    ry: 1.65,
    fill: "url(#metrics_svg__b)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.15,
    cy: 2.15,
    rx: 1.64,
    ry: 1.65,
    fill: "url(#metrics_svg__c)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.85,
    cy: 10.22,
    rx: 1.64,
    ry: 1.65,
    fill: "url(#metrics_svg__d)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.67,
    y: 9.92,
    width: 2.58,
    height: 7.58,
    rx: 0.28,
    fill: "#0078d4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.78,
    y: 12.54,
    width: 2.58,
    height: 4.96,
    rx: 0.28,
    fill: "#005ba1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.89,
    y: 7.38,
    width: 2.58,
    height: 10.12,
    rx: 0.28,
    fill: "#005ba1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.56,
    y: 12.54,
    width: 2.58,
    height: 4.96,
    rx: 0.28,
    fill: "#5ea0ef"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgMetrics as ReactComponent };